import { connect } from 'react-redux';

import CloseButton from 'presentation/components/icons/CloseButton';
import { getCloseButton } from 'app/modules';
import minimizeWidget from 'actions/ui/minimizeWidget';
import { trackWidgetClosed } from 'events/analytics';

export const mapStateToProps = (state, props) => {
  const closeButton = getCloseButton(state);
  return {
    ...props,
    iconType: closeButton.iconType,
    title: closeButton.title,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  const minimize = function(autofocus) {
    ownProps.setAutoFocusMinimizedChat(autofocus);
    dispatch(minimizeWidget);
    dispatch(trackWidgetClosed());
  };

  return {
    onClick: () => {
      minimize(false);
    },
    onKeyDown: event => {
      if (event.key === 'Enter') {
        minimize(true);
      }
    },
  };
};

const CloseButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CloseButton);

export default CloseButtonContainer;
